import { MapPin } from "lucide-react";

// Aviso "GPS ao vivo" + instrução de manter a página aberta + status de rede/fila/wake lock.
export function MobileTrackingBlock({ wakeLockSupported, wakeLockActive, netOnline, pingQueueSize }) {
  return (
    <div className="mt-3 space-y-2" data-testid="mobile-tracking-block">
      <div className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase bg-emerald-600 text-white px-2.5 py-1 rounded-full shadow-sm" data-testid="mobile-tracking-badge">
        <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
        GPS Ao Vivo · enviando a cada 30s
      </div>
      <div className="mx-auto max-w-md rounded-xl border-2 border-emerald-200 bg-emerald-50 px-3 py-2 text-[12px] text-emerald-900 leading-snug shadow-sm" data-testid="mobile-tracking-instruction">
        <div className="font-extrabold uppercase text-[11px] tracking-wide mb-0.5 flex items-center gap-1.5">
          <MapPin className="w-3.5 h-3.5" />
          Mantenha esta página aberta
        </div>
        <div>
          Para o rastreamento funcionar, deixe o app em primeiro plano e não bloqueie a tela.
          {wakeLockSupported
            ? (wakeLockActive ? " A tela ficará acesa automaticamente." : " (tentando manter tela ativa…)")
            : " Ajuste o tempo da tela nas configurações do celular."}
        </div>
        <div className="mt-1.5 flex flex-wrap items-center gap-1.5 text-[10px] font-semibold">
          <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full ${netOnline ? "bg-emerald-600 text-white" : "bg-red-600 text-white animate-pulse"}`}
            data-testid="mobile-tracking-net-status" data-online={netOnline ? "true" : "false"}>
            <span className="w-1.5 h-1.5 rounded-full bg-white"></span>
            {netOnline ? "Online" : "Sem internet"}
          </span>
          {pingQueueSize > 0 && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-500 text-white" data-testid="mobile-tracking-queue-badge" data-queue-size={pingQueueSize}>
              {pingQueueSize} ponto{pingQueueSize !== 1 ? "s" : ""} aguardando envio
            </span>
          )}
          {wakeLockSupported && wakeLockActive && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-violet-600 text-white" data-testid="mobile-wakelock-badge">Tela ativa</span>
          )}
        </div>
      </div>
    </div>
  );
}
